<c-card *transloco="let t">
    <c-card-body class="px-2">

            <c-row>
              <c-col md="12">
                <h1>{{ t('Feature Request for OK Alone') }}</h1>
                <p>
                    {{ t('We always strive to improve the OK Alone system and include any feature requests user may have. If you have any comments, feature requests or issues, please use the form below to submit them.') }}
                </p>

                <p>
                    {{ t('If you have any urgent issues please email us at ') }}<a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.
                </p>

                <ng-container *ngIf="!submitted">

                    <div class="form-floating mb-2">
                      <textarea class="form-control" placeholder="Leave a comment here" id="floatingTextarea" style="max-width:500px;height: 150px;" rows="5" [(ngModel)]="feature"></textarea>
                      <label for="floatingTextarea">{{ t('Tell us about your feature request') }}</label>
                      <span class="text-danger" *ngIf="error">{{ t('Please enter your feature request')}}</span>
                    </div>

                    <button type="button" class="btn btn-info text-white" (click)="cancelBeta()">{{ t('Submit Feature Request') }}</button>

                </ng-container>

                <ng-container *ngIf="submitted">
                    <div class="alert alert-success" role="alert">
                        {{ t('The feature request has been submitted. We will review this soon and get in touch. Thank you.') }}
                    </div>
                </ng-container>



              </c-col>
            </c-row>


    </c-card-body>
  </c-card>


